<template>
  <div id="reporter" style="margin-top: 10px">
    <div>
      <div v-if="isSelectedBot">
        <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
          <template v-if="selectedBot.theme !== 'oab'">
            <v-tab ripple :key="'reporter-admin'" :href="'#reporter-admin'">{{
              $t('Admin')
            }}</v-tab>
            <v-tab ripple :key="'reporter-user'" :href="'#reporter-user'">{{ $t('User') }}</v-tab>
          </template>
          <v-tab
            v-if="selectedBot.theme == 'oab'"
            ripple
            :key="'product-list'"
            :href="'#product-list'"
            >{{ $t('Product lists') }}</v-tab
          >
        </v-tabs>
        <v-container fluid>
          <keep-alive>
            <component :is="currentView"></component>
          </keep-alive>
        </v-container>
      </div>
      <div v-else>
        <template-empty></template-empty>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import reporterAdmin from './reporter-admin'
import reporterUser from './reporter-user'
import productList from './product-list'
import templateEmpty from '@/components/view/template/template-empty'

export default {
  data: function () {
    return {
      currentView: 'reporter-admin'
    }
  },
  components: {
    'reporter-admin': reporterAdmin,
    'reporter-user': reporterUser,
    'template-empty': templateEmpty,
    productList
  },
  created() {
    let vm = this
    if (vm.$route.query.tab) {
      switch (vm.$route.query.tab) {
        case 'reporter-admin':
        case 'reporter-user':
          vm.currentView = vm.$route.query.tab
          break
        default:
          vm.currentView = 'reporter-admin'
          break
      }
    } else {
      if (this.selectedBot.theme == 'oab') {
        vm.currentView = 'product-list'
      } else {
        vm.currentView = 'reporter-admin'
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      welcomemessage: 'welcomeMessage'
    }),
    isSelectedBot: function () {
      return this.$store.state.isSelectedBot
    }
  },
  methods: {
    updateRoute: function () {
      this.$router.push({
        name: 'template',
        path: '/template',
        query: {
          tab: this.currentView
        }
      })
      this.routeValue = JSON.stringify(this.$route.query)
    }
  },
  watch: {
    currentView: function () {
      this.updateRoute()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/reporter/reporter.vue